//  the process key/value pair specifies which document can be used in which process
// process: ["renewal", "newreg", "changeowner", "drivlicense"],
const { vehicleProcess } = require("../../constants")
const customizedNumberPlate = require("../multi-city/customized-number-plate")
const {
  comprehensiveInsuranceDocs,
} = require("../multi-city/comprehensive-insurance")
const { vehicleTrackingDocs } = require("../multi-city/vehicle-tracking")

const { RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE } = vehicleProcess

const lgDocs = [
  { desc: "Local govt paper", docs: { sw: 4500, ng: 10500 } },
  { desc: "JTB - Joint Tax Board", docs: { sw: 9000, ng: 9000 } },
  { desc: "National Unified ByPass (NUBS)", docs: { sw: 3500, ng: 3500 } },
  { desc: "Urban access", docs: { sw: 0, ng: 4500 } },
  { desc: "Drive way permit", docs: { sw: 2500, ng: 2500 } },
  { desc: "Environmental Devt.Levy (EDL) Light", docs: { sw: 4500, ng: 4500 } },
  { desc: "Daily toll", docs: { sw: 9000, ng: 9000 } },
  { desc: "Basket or Stickers", docs: { sw: 3500, ng: 3500 } },
  { desc: "Heavy and Light Duty", docs: { sw: 2500, ng: 2500 } },
]

const totalLg = (region) => {
  return lgDocs.reduce(
    (total, doc) => {
      total.cost += doc.docs[region]
      total.desc += `, ${doc.desc}`
      return total
    },
    { desc: "Covers for", cost: 0 },
  )
}
const LG_NG = totalLg("ng")
const LG_SW = totalLg("sw")

const docs = (typeOfDoc = "private", typeOfPlate = "regular") => [
  {
    key: "vl",
    name: "Vehicle Licence",
    description: "Required for every vehicle",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 1500, price: 2500 }, // +1000
      { cost: 2800, price: 3800 },
      { cost: 3300, price: 4300 },
      { cost: 4000, price: 5000 },
      { cost: 6600, price: 7600 },
      { cost: 7100, price: 8100 }, // + 1000
      { cost: 7100, price: 8100 },
      { cost: 7100, price: 8100 },
    ],
    meta: {},
  },
  {
    key: "rw",
    name: "Road Worthiness (Referral Note)",
    description: "Required for every vehicle",
    connected: ["poc"],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price:
      typeOfDoc === "private"
        ? [
            { cost: 0, price: 0 },
            { cost: 8000, price: 9200 }, // +1200
            { cost: 8000, price: 9200 },
            { cost: 8700, price: 9900 },
            { cost: 8700, price: 9900 },
            { cost: 14000, price: 15200 },
            { cost: 14000, price: 15200 },
            { cost: 16500, price: 17700 },
            { cost: 16500, price: 17700 },
          ]
        : [
            { cost: 0, price: 0 },
            { cost: 7000, price: 8200 }, // +1200
            { cost: 7000, price: 8200 },
            { cost: 7700, price: 8900 },
            { cost: 8700, price: 9900 },
            { cost: 14000, price: 15200 },
            { cost: 14000, price: 15200 },
            { cost: 16500, price: 17700 },
            { cost: 16500, price: 17700 },
          ],
    meta: {},
  },
  {
    key: "ins",
    name: "Third Party Insurance",
    description:
      "Either a third-party or comprehensive insurance is required for vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price:
      typeOfDoc === "private"
        ? [
            { cost: 0, price: 0 },
            { cost: 4000, price: 5000 },
            { cost: 13000, price: 15000 },
            { cost: 13000, price: 15000 },
            { cost: 13000, price: 15000 },
            { cost: 17000, price: 20000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
          ]
        : [
            { cost: 0, price: 0 },
            { cost: 4000, price: 5000 },
            { cost: 17000, price: 20000 },
            { cost: 17000, price: 20000 },
            { cost: 17000, price: 20000 },
            { cost: 17000, price: 20000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
            { cost: 80000, price: 100000 },
          ],
    meta: {},
  },
  {
    ...comprehensiveInsuranceDocs,
  },
  {
    key: "hp",
    name: "Hackney Permit",
    description: "Required for commercial vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 2500, price: 3500 }, // +1000
      { cost: 4100, price: 5100 },
      { cost: 4100, price: 5100 },
      { cost: 4800, price: 5800 },
      { cost: 4800, price: 5800 },
      { cost: 6600, price: 7600 },
      { cost: 6600, price: 7600 },
      { cost: 6600, price: 7600 },
    ],
    meta: {},
  },
  {
    key: "poc",
    name: "Proof of Ownership Certificate",
    description: "Required for all vehicles (can't be renewed alone)",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 1500, price: 2800 }, // +1300
      { cost: 1500, price: 2800 },
      { cost: 1500, price: 2800 },
      { cost: 1500, price: 2800 },
      { cost: 1500, price: 2800 },
      { cost: 1500, price: 2800 },
      { cost: 1500, price: 2800 },
      { cost: 1500, price: 2800 },
    ],
    meta: {
      disabled: true,
    },
  },
  {
    key: "cmr",
    name: "Central Motor Registry (eCMR)",
    description: "Required for all vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 3,
    price: [
      { cost: 0, price: 0 },
      { cost: 5700, price: 7200 }, // +1500
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
      { cost: 5700, price: 7200 },
    ],
    meta: {},
  },
  {
    key: "autovin",
    name: "Auto VIN",
    description: "Required for all vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 7000, price: 8000 }, // +1000
      { cost: 7000, price: 8000 },
      { cost: 7000, price: 8000 },
      { cost: 7000, price: 8000 },
      { cost: 7000, price: 8000 },
      { cost: 7000, price: 8000 },
      { cost: 7000, price: 8000 },
      { cost: 7000, price: 8000 },
    ],
    meta: {
      disabled: true,
    },
  },
  {
    key: "npr",
    name:
      typeOfPlate === "regular" ||
      typeOfPlate === "regular-custom-lg" ||
      typeOfPlate === "commercial-red-plate"
        ? "Number Plate Reprint"
        : "Number Plate Reprint (Customized)",
    description: "Optional, can be ordered on-demand",
    connected: [],
    process: [RENEWAL, ESTIMATE],
    processingTime: 7,
    price:
      typeOfPlate === "regular" ||
      typeOfPlate === "regular-custom-lg" ||
      typeOfPlate === "commercial-red-plate"
        ? [
            { cost: 0, price: 0 },
            { cost: 40000, price: 48000 },
            { cost: 40000, price: 48000 },
            { cost: 40000, price: 48000 },
            { cost: 40000, price: 48000 },
            { cost: 40000, price: 48000 },
            { cost: 97000, price: 112000 },
            { cost: 97000, price: 112000 },
            { cost: 97000, price: 112000 },
          ]
        : customizedNumberPlate,
    meta: {},
  },
  {
    key: "lg",
    name: "L/Govt. Permit (Nigeria)",
    description: LG_NG.desc,
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
      { cost: LG_NG.cost, price: LG_NG.cost + 5500 },
    ],
    meta: {},
  },
  {
    key: "lgsw",
    name: "L/Govt. Permit (SouthWest)",
    description: LG_SW.desc,
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 }, // +4000
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
      { cost: LG_SW.cost, price: LG_SW.cost + 4000 },
    ],
    meta: {},
  },
  {
    key: "sc",
    name: "State Carriage Permit",
    description: "Required for commercial vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 6000, price: 7000 }, // +1000
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
      { cost: 7500, price: 8500 },
    ],
    meta: {},
  },
  {
    key: "hvp",
    name: "Heavy Duty Permit",
    description: "Required for trucks & pickups",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 7500, price: 9500 }, // +2000
      { cost: 7500, price: 9500 },
      { cost: 7500, price: 9500 },
      { cost: 7500, price: 9500 },
      { cost: 11500, price: 13500 },
      { cost: 11500, price: 13500 },
      { cost: 11500, price: 13500 },
    ],
    meta: {},
  },
  {
    key: "ttp",
    name: "Trailer & Tipper Permit (TTP)",
    description: "Required for trucks",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 5000, price: 6500 }, // +1500
      { cost: 5000, price: 6500 },
      { cost: 5000, price: 6500 },
      { cost: 5000, price: 6500 },
    ],
    meta: {},
  },
  {
    key: "myp",
    name: "Mid Year Permit",
    description: "Required for commercial vehicles every mid year",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 2000, price: 4000 }, // + 2000
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
      { cost: 2000, price: 4000 },
    ],
    meta: {},
  },
  {
    key: "nubs",
    name: "National Unified ByPass (NUBS)",
    description: "Required for commercial vehicles",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 2,
    price: [
      { cost: 0, price: 0 },
      { cost: 2500, price: 4000 }, // + 1500
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
      { cost: 2500, price: 4000 },
    ],
    meta: {},
  },
  {
    key: "mdc",
    name: "MOT (Despatch Certificate)",
    description: "Required for dispatch bikes",
    connected: [],
    process: [RENEWAL, NEW_REG, CHANGE_OWNER, ESTIMATE],
    processingTime: 8,
    price: [
      { cost: 0, price: 0 },
      { cost: 25000, price: 29000 }, // + 4000
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
      { cost: 0, price: 0 },
    ],
    meta: {},
  },
  {
    key: "addToDb",
    name: "Addition to Lagos Database",
    description:
      "Required for adding vehicles registered in other states to Lagos database",
    connected: [],
    process: [RENEWAL, ESTIMATE],
    processingTime: 5,
    price: [
      { cost: 0, price: 0 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
      { cost: 5500, price: 8500 },
    ],
    meta: {},
  },
  {
    key: "backup",
    name: "Digital Documents Backup",
    description:
      "Will save digital copies of your documents so you can access them in app for a year",
    connected: [],
    process: [],
    processingTime: 5,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
      { cost: 0, price: 500 },
    ],
    meta: {},
  },
  // others,
  {
    key: "np",
    name:
      typeOfPlate === "regular"
        ? "Number Plate"
        : typeOfPlate === "regular-custom-lg"
          ? "Number Plate (Custom LG)"
          : typeOfPlate === "commercial-red-plate"
            ? "Number Plate (Commercial - Red Plate)"
            : "Number Plate (Customized)",
    description: "Required for during new registration for all vehicles",
    connected:
      typeOfPlate === "commercial-red-plate"
        ? ["vl", "rw", "poc", "cmr", "autovin", "hp"]
        : ["vl", "rw", "poc", "cmr", "autovin"],
    process: [NEW_REG, CHANGE_OWNER],
    processingTime:
      typeOfPlate === "regular" || typeOfPlate === "commercial-red-plate"
        ? 3
        : typeOfPlate === "regular-custom-lg"
          ? 7
          : 45,
    price:
      typeOfPlate === "regular" || typeOfPlate === "commercial-red-plate"
        ? [
            { cost: 0, price: 0 },
            { cost: 78000, price: 90000 }, // +4000
            { cost: 52000, price: 56000 },
            { cost: 52000, price: 56000 },
            { cost: 52000, price: 56000 },
            { cost: 52000, price: 56000 },
            { cost: 103000, price: 113000 }, // + 10000
            { cost: 103000, price: 113000 },
            { cost: 103000, price: 113000 },
          ]
        : typeOfPlate === "regular-custom-lg"
          ? [
              { cost: 0, price: 0 },
              { cost: 78000, price: 110000 }, // +4000 + 20000
              { cost: 52000, price: 76000 },
              { cost: 52000, price: 56000 },
              { cost: 52000, price: 76000 },
              { cost: 52000, price: 76000 },
              { cost: 103000, price: 13000 }, // +10000 + 20000
              { cost: 103000, price: 133000 },
              { cost: 103000, price: 133000 },
            ]
          : customizedNumberPlate,
    meta: {},
  },
  {
    key: "coc",
    name: "Change of Ownership Certificate",
    description:
      "Required during transfer of ownership of a registered vehicle",
    connected: ["np", "vl", "rw", "poc", "cmr", "autovin"],
    process: [CHANGE_OWNER],
    processingTime: 21,
    price: [
      { cost: 0, price: 0 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
      { cost: 30000, price: 35000 },
    ],
    meta: {},
  },
  {
    ...vehicleTrackingDocs,
  },
  {
    key: "processing",
    name: "Processing Fee",
    description:
      "Covers our fees for documents processing & handling with digital document backup that you can acess in app for a year",
    connected: [],
    process: [RENEWAL, ESTIMATE, CHANGE_OWNER, NEW_REG],
    processingTime: 1,
    price: [
      { cost: 0, price: 0 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
      { cost: 0, price: 2000 },
    ],
    meta: {
      disabled: true,
      // notDelivered: true,
      alwaysSelect: true,
    },
  },
]

module.exports = { docs }
